var path = 'src/app/forms/fields/weeks-and-days-field.html';
var html = "<div frm-model frm-required frm-weeks-and-days ng-required=required() ng-model=model> <div class=row> <div class=col-md-6> <div frm-field frm-group-inline> <div class=input-group> <input frm-model integer-validator ng-model=period.weeks class=form-control /> <span class=input-group-addon>weeks</span> </div> </div> </div> <div class=col-md-6> <div frm-field frm-group-inline> <div class=input-group> <input frm-model integer-validator ng-model=period.days class=form-control /> <span class=input-group-addon>days</span> </div> </div> </div> </div> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/forms/fields/weeks-and-days-field.html
 ** module id = 308
 ** module chunks = 0
 **/